import { initContract } from '@ts-rest/core'
import { ErrorResponseSchema } from './general'
import type { GroupedProducts, MealRecommendationsResult } from '@repo/api-types'
import z from 'zod'

const c = initContract()

export const productContract = c.router(
  {
    getProducts: {
      method: 'GET',
      path: '/products',
      responses: {
        200: c.type<GroupedProducts>(),
      },
    },
    getMealRecommendations: {
      method: 'GET',
      path: '/meal-recommendations/:animalId',
      pathParams: z.object({
        animalId: z.string().uuid(),
      }),
      responses: {
        200: c.type<MealRecommendationsResult>(),
      },
    },
  },
  {
    commonResponses: {
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema,
    },
  },
)
